import AppProductPriceLegalNotice from 'apps/productPriceLegalNotice/desktop';

function initFreeShippingTooltip () {

	const container = document.querySelectorAll('.freeReturnsContainer');

	if (container) {

		container.forEach((el) => {

			if (el.innerText !== '') {

				const tooltipTrigger = el.querySelector('.freeShippingTooltip_trigger');
				AppProductPriceLegalNotice(el, tooltipTrigger, { evtType: 'click' }, '.freeShippingTooltip',
					'.freeShippingTooltip__content');

			}

		});

	}

	const shippingWrapperQL = document.querySelector('.shippingWrapperQL');
	if (shippingWrapperQL) {

		const tooltipTrigger = shippingWrapperQL.querySelector('.freeShippingTooltip_trigger');
		if (tooltipTrigger) {

			AppProductPriceLegalNotice(shippingWrapperQL, tooltipTrigger, { evtType: 'click' }, '.freeShippingTooltip',
				'.freeShippingTooltip__content');

		}

	}

}

export default initFreeShippingTooltip;
